import { h, Component } from 'preact';
import { joinClasses } from 'utils/utils';
import { logOut } from 'utils/login';
import { canUser, getRoleName } from 'utils/roles';
import { isBaseRegion } from 'utils/studioConfig';
import { showUsers } from 'components/users/users';
import { showUserSettings } from 'components/userSettings/userSettings';

import Button from 'components/button/button';
import Movies from 'components/list/movieList';
import HubPages from 'components/list/hubPagesList';
import Navigation from 'components/main/navigation/navigation';
import Media from 'components/list/mediaList';
import Powster from 'components/icons/powster';
import IconArrowRightShort from 'components/icons/arrowRightShort';
import IconSettings from 'components/icons/settings';
import IconUsers from 'components/icons/users';
import RegionSelector from 'components/regionSelector/regionSelector';

import ComponentsTest from 'components/main/componentsTest';

import s from 'components/main/main.sss';

const pagesContent = {
	'components-test': (__IS_LOCAL__ || __IS_DEMO__) && ComponentsTest,
	movies: Movies,
	pages: HubPages,
	navigation: Navigation,
	media: Media,
};

export default class Main extends Component {
	constructor(props) {
		super(props);

		this.openUserSettings = this.openUserSettings.bind(this);
	}

	async logOut() {
		logOut();
	}

	async openUserSettings() {
		await showUserSettings(this.props.user);
	}

	renderUserDetails() {
		const user = this.props.user;

		return (
			<div class={s.user}>
				<RegionSelector />
				<div class={s.userInfo}>
					<div class={s.name}>
						{user?.name || 'Your account'}
						<button onClick={this.openUserSettings}><IconSettings /></button>
					</div>
					<div class={s.role}>{getRoleName()}</div>
				</div>
				<button class={s.logOut} onClick={this.logOut}>Log out<IconArrowRightShort /></button>
			</div>
		);
	}

	renderSidebar() {
		const topPath = this.props.path[0];
		const isBase = isBaseRegion();
		const nav = [
			{ path: 'movies', label: 'Movies' },
			!isBase && { path: 'pages', label: 'Pages' },
			!isBase && { path: 'navigation', label: 'Navigation & legal' },
			{ path: 'media', label: 'Media' },
		].filter(Boolean);

		// Add a postfix to the title to indicate the environment (dev, stage, QA)
		let titlePostfix = '';
		if (__IS_LOCAL__ || __IS_DEMO__) {
			titlePostfix = '| Dev';
		} else {
			const hostname = typeof window !== 'undefined' ? location.origin : '';
			if (hostname.includes('stage.cms.universalpictures.com')) {
				titlePostfix = '| Stage';
			}
			if (hostname.includes('cms.qa.nbcunip.com')) {
				titlePostfix = '| QA';
			}
		}

		return (
			<header class={s.sidebar}>
				<h1 class={s.branding}><Powster class={s.powster} aria-label="POWSTER" /> CMS {titlePostfix}</h1>
				{this.renderUserDetails()}
				<nav class={s.nav}>
					{nav.map(e => (
						<a href={`#${e.path}`} class={joinClasses(s.item, topPath === e.path && s.active)} tabIndex={topPath === e.path ? -1 : null}>
							{e.label}
						</a>
					))}
				</nav>
				<div class={s.bottom}>
					{canUser('user_manage') && <Button icon={IconUsers} onClick={showUsers} key="users">Users</Button>}
					<Button icon="help" href="https://docs.google.com/document/d/1J68gruMHkDUFeNhk6ZqpBxN6d10unIw14inkgHJJnGk/edit?tab=t.0" target="_blank" key="help">Help</Button>
				</div>
			</header>
		);
	}

	renderContent() {
		const topPath = this.props.path[0];
		let Component = pagesContent[topPath];
		// TODO: 404?
		// if (!Component) {
		// 	Component = Error404;
		// }
		return (
			<main class={s.content}>
				<Component {...this.props} />
			</main>
		);
	}

	render(props, state) {
		// No fragments in our current Preact version, use display: contents for now
		return (
			<div class={s.wrapper}>
				{this.renderSidebar()}
				{this.renderContent()}
			</div>
		);
	}
}
